import { render, staticRenderFns } from "./diffFeeDialog.vue?vue&type=template&id=384186e6&"
import script from "./diffFeeDialog.vue?vue&type=script&lang=js&"
export * from "./diffFeeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports